import { createAsyncThunk } from "@reduxjs/toolkit";
import "react-toastify/dist/ReactToastify.css";

//Include Both Helper File with needed methods
import {
  getClientList as getClientListApi,
  getClosedTrades as getClosedTradesApi,
  getDeals as getDealsApi,
  getEquityReport as getEquityReportApi,
  getMoneyTransferReport as getMoneyTransferReportApi,
  getOpenPositions as getOpenPositionsApi,
  getSubIbList as getSubIbListApi,
  getTopClientReport as getTopClientReportApi,
  getAllInstrumentGroups as getAllInstrumentGroupsApi,
  getOfficesInfo as getOfficesInfoApi,
  getLoginInfo as getLoginInfoApi,
  getSymbolInfo as getSymbolInfoApi,
} from "../../helpers/ServiceHelpers/backend_helper";

// Get Client List
export const getClientList = createAsyncThunk(
  "reports/getClientList",
  async (params: any) => {
    const { id, data } = params;
    try {
      const response = getClientListApi(id, data);
      return response;
    } catch (error) {
      return error;
    }
  }
);

// Get Closed Trades
export const getClosedTrades = createAsyncThunk(
  "reports/getClosedTrades",
  async (params: any) => {
    const { id, data } = params;
    try {
      const response = getClosedTradesApi(id, data);
      return response;
    } catch (error) {
      return error;
    }
  }
);

// Get Deals
export const getDeals = createAsyncThunk(
  "reports/getDeals",
  async (params: any) => {
    const { id, data } = params;
    try {
      const response = getDealsApi(id, data);
      return response;
    } catch (error) {
      return error;
    }
  }
);

// Get Equity Report
export const getEquityReport = createAsyncThunk(
  "reports/getEquityReport",
  async (params: any) => {
    const { id, data } = params;
    try {
      const response = getEquityReportApi(id, data);
      return response;
    } catch (error) {
      return error;
    }
  }
);

// Get Money Transfer Report
export const getMoneyTransferReport = createAsyncThunk(
  "reports/getMoneyTransferReport",
  async (params: any) => {
    const { id, data } = params;
    try {
      const response = getMoneyTransferReportApi(id, data);
      return response;
    } catch (error) {
      return error;
    }
  }
);

// Get Open Positions
export const getOpenPositions = createAsyncThunk(
  "reports/getOpenPositions",
  async (params: any) => {
    const { id, data } = params;
    try {
      const response = getOpenPositionsApi(id, data);
      return response;
    } catch (error) {
      return error;
    }
  }
);

// Get SubIb List
export const getSubIbList = createAsyncThunk(
  "reports/getSubIbList",
  async (params: any) => {
    const { id, data } = params;
    try {
      const response = getSubIbListApi(id, data);
      return response;
    } catch (error) {
      return error;
    }
  }
);

// Get Top Client Report
export const getTopClientReport = createAsyncThunk(
  "reports/getTopClientReport",
  async (params: any) => {
    const { id, data } = params;
    try {
      const response = getTopClientReportApi(id, data);
      return response;
    } catch (error) {
      return error;
    }
  }
);

// Get All Instrument Groups
export const getAllInstrumentGroups = createAsyncThunk(
  "get/AllInstrumentGroups",
  async () => {
    try {
      const response = getAllInstrumentGroupsApi();
      return response;
    } catch (error) {
      return error;
    }
  }
);

// Get Offices Info
export const getOfficesInfo = createAsyncThunk(
  "get/getOfficesInfo",
  async () => {
    try {
      const response = getOfficesInfoApi();
      return response;
    } catch (error) {
      return error;
    }
  }
);

// Get Login Info
export const getLoginInfo = createAsyncThunk(
  "get/loginInfo",
  async ({
    partnerId,
    searchString,
  }: {
    partnerId: number;
    searchString: string;
  }) => {
    try {
      const response = getLoginInfoApi(partnerId, searchString);
      return response;
    } catch (error) {
      return error;
    }
  }
);

// Get Symbol Info
export const getSymbolInfo = createAsyncThunk(
  "get/symbolInfo",
  async ({
    partnerId,
    searchString,
  }: {
    partnerId: number;
    searchString: string;
  }) => {
    try {
      const response = getSymbolInfoApi(partnerId, searchString);
      return response;
    } catch (error) {
      return error;
    }
  }
);
